import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from './components/Dropdown'
import { deleteEvent, fetchEventById, fetchEvents, updateEvent } from "../../services/events";
import MDEditor from '@uiw/react-md-editor';
import _, { set, times, wrap } from 'lodash';
import { HexColorPicker } from "react-colorful";
import RemoveSvg from '../../svgs/RemoveSvg'
import FileDropzone from '../../components/FileDropzone'
import { uploadPhoto } from "../../services/documents";
import EventRegistrationForm from "./components/EventRegistrationForm";
import EventApprovalPage from "./components/EventApproval";
import EventIntroduction from "./components/EventIntroduction";
import EventComments from "./components/EventComments";
import EventDetailsEditor from "./components/EventDetailsEditor";
import EventEmail from "./components/EventEmail";
import RefreshButton from '../../svgs/RefreshButton'
import SaveButton from '../../svgs/SaveButton'

const TABS = ['活動內容', '活動簡介', '詳細資訊','活動報名', '登記電郵通知', '批准電郵通知',
     //'管理評論'
     ,'報名表']

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token])

    async function fetchData() {
        let res = await fetchEventById(id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }

    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }

    const onDropImageFile = async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, `preview`)
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updateEvent(props.token?.token, id, { preview: filepath });
                setData({ ...data, preview: filepath })
            }
        }
        setIsloading(false);
    }
    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('活動名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updateEvent(props.token?.token, id, {
            name: data.name,
            status: data.status,
            subtitle: data.subtitle || "",
            date: data.date || '',
            time: data?.time || '',
            location: data.location || '',
            isParticipationDisabled: data.isParticipationDisabled || false,
            isRequireApproval: data.isRequireApproval || false,
            isRecommended: data.isRecommended || false,
            preview: data.preview || '',
            email: data.email || {},
            order: data.order || 99,
            registrationForm: data.registrationForm || {},
            isWechatDeposit: data.isWechatDeposit || false,
            depositFee: data.depositFee? (data.depositFee>=0 ? data.depositFee : 0) : 0,
        });
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }




    const [tab, setTab] = useState(TABS[0])




    {/*introduction handler*/ }
    const handleIntroductionOrder = (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data.introduction[oldIndex]);
        }
        let d = { ...data };
        d.introduction = array;
        setData(d);
    }
    const handleAddIntroduction = () => {
        let d = { ...data };
        let introduction = [...(d.introduction || [])]
        introduction.push({ id: Date.now(),type: 'text', content:'',isTitle:false})
        d.introduction = introduction
        setData(d);
    }
    const handleSectionDeleteIntroduction = (card, cardIndex) => {
        let d = { ...data }
        let introduction = d.introduction;
        introduction.splice(cardIndex, 1);
        d.introduction = introduction;
        setData(d)
    }
    const handleSectionEditIntroduction = (card, cardIndex, key, value) => {
        let d = { ...data };
        d.introduction[cardIndex][key] = value
        setData(d);
    }
    {/*introduction handler*/ }

    {/*details handler*/ }
    const handleDetailsOrder = (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data.details[oldIndex]);
        }
        let d = { ...data };
        d.introduction = array;
        setData(d);
    }
    const handleAddDetails = () => {
        let d = { ...data };
        let details = [...(d.details || [])]
        details.push({ id: Date.now(),type: 'text', content:'',isTitle:false})
        d.details = details
        setData(d);
    }
    const handleSectionDeleteDetails = (card, cardIndex) => {
        let d = { ...data }
        let details = d.details;
        details.splice(cardIndex, 1);
        d.details = details;
        setData(d)
    }
    const handleSectionEditDetails = (card, cardIndex, key, value) => {
        let d = { ...data };
        d.details[cardIndex][key] = value
        setData(d);
    }
    {/*details handler*/ }

    const [isDeleting, setIsDeleting] = useState(false)
    const startDeleteEvent=()=>{setIsDeleting(true)}
    const handleDelete=async ()=>{
        setIsloading(true)
        let result = await deleteEvent(props.token?.token, id)
        if (result.errno) {
            alert(result.message || '刪除失敗')
            setIsloading(false)
        } else {
            alert('刪除成功')
            navigate('/cms/events')
        }
    }


    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className='p-[16px] relative rounded-[7px] w-full p-[16px] z-[2] flex flex-row'>
                <div className="flex flex-col z-[2]">
                    <div className="font-[700] text-[24px]">{data.name}</div>
                    <div className="text-[12px]">活動管理 {'>'} {data.name}</div>
                </div>
                <div className="flex flex-row  flex-1 items-center justify-end gap-[8px] z-[2]">
                    <div onClick={startDeleteEvent} className="cursor-pointer hover:opacity-[.5]">
                        <DeleteButton />
                    </div>
                    <div  onClick={save} className="cursor-pointer hover:opacity-[.5]">
                        <SaveButton />
                    </div>
                    <div  onClick={refresh} className="cursor-pointer hover:opacity-[.5]">
                        <RefreshButton />
                    </div>
                    <div  onClick={navigateTo('/cms/events')} className="cursor-pointer hover:opacity-[.5]">
                        <BackButton />
                    </div>
                    
                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>
            <div className="w-full flex flex-row gap-[16px] flex-wrap" style={{ borderBottom: '2px solid #fff' }}>
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer mb-[-2px]" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            {tab === '活動內容' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動名稱</div>
                        <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='活動名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動狀態</div>
                        <DropdownMenu options={['已公開', '草稿']}
                            value={data?.status === 'published' ? '已公開' : '草稿'}
                            select={(item, index) => {
                                setData({ ...data, status: item === '已公開' ? 'published' : 'draft' })
                            }}
                        />
                    </div>
                    <div className="flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]">
                        <div className='font-[700]'>活動副標題</div>
                        <input value={data?.subtitle || ''} onChange={(e) => { setData({ ...data, subtitle: e.target.value }) }} placeholder='活動副標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動日期</div>
                        <input value={data?.date || ''} onChange={(e) => { setData({ ...data, date: e.target.value }) }} placeholder='活動日期' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動時間</div>
                        <input value={data?.time || ''} onChange={(e) => { setData({ ...data, time: e.target.value }) }} placeholder='活動時間' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動地點</div>
                        <input value={data?.location || ''} onChange={(e) => { setData({ ...data, location: e.target.value }) }} placeholder='活動地點' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 顯示順序（數值越大，顯示越前）</div>
                        <input value={data?.order ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 99
                            setData({ ...data, order: num < 0 ? 0 : num })
                        }} placeholder='顯示順序' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>

                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>需要填寫報名表參與</div>
                        <DropdownMenu options={['需要填寫報名表參與', '直接從應用程式參與']}
                            value={data?.isParticipationDisabled ? '需要填寫報名表參與' : '直接從應用程式參與'}
                            select={(item, index) => {
                                setData({ ...data, isParticipationDisabled: item === '需要填寫報名表參與' })
                            }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>需要審批才能用QRCode進入會場</div>
                        <DropdownMenu options={['需要審批', '不需要審批']}
                            value={data?.isRequireApproval ? '需要審批' : '不需要審批'}
                            select={(item, index) => {
                                setData({ ...data, isRequireApproval: item === '需要審批' })
                            }}
                        />
                    </div>
                    <div className='w-full flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>推薦活動</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isRecommended ? '是' : '否'}
                            select={(item, index) => {
                                setData({ ...data, isRecommended: item === '是' })
                            }}
                        />
                    </div>


                    <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>出席環節(Attendance Session)</div>
                        <DropdownMenu options={['啟用', '不啟用']}
                            value={data?.registrationForm?.enableAttendanceSession ? '啟用' : '不啟用'}
                            select={(item, index) => {
                                setData({ ...data, registrationForm: { ...(data?.registrationForm || {}), enableAttendanceSession: item === '啟用' } })
                            }}
                        />
                        {data?.registrationForm?.enableAttendanceSession && (data?.registrationForm?.attendanceSessions || []).map((session, index) =>
                            <div key={index} className="flex flex-row w-full gap-[4px] mt-[8px] items-center justify-between">
                                <div className='font-[700]'>環節{Number(index) + 1}:</div>
                                <input className='p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                    value={session.name || ''}
                                    onChange={(e) => {
                                        const newSessions = [...(data?.registrationForm?.attendanceSessions || [])];
                                        newSessions[index].name = e.target.value;
                                        setData({ ...data, registrationForm: { ...(data?.registrationForm || {}), attendanceSessions: newSessions } })
                                    }}
                                />
                                <div className="cursor-pointer hover:opacity-[.5]" onClick={() => {
                                    const newSessions = [...(data?.registrationForm?.attendanceSessions || [])];
                                    newSessions.splice(index, 1);
                                    setData({ ...data, registrationForm: { ...(data?.registrationForm || {}), attendanceSessions: newSessions } })
                                }}>
                                    <RemoveSvg />
                                </div>
                            </div>
                        )}
                        <div className="flex flex-row items-start justify-start gap-[8px] mt-[8px]">
                            <div className="cursor-pointer hover:opacity-[.5] text-center rounded-[4px] text-[white] font-[700] text-[12px] bg-[#0F737E] p-[4px]" onClick={() => {
                                let newSessions = [...(data?.registrationForm?.attendanceSessions || []), { name: '' }];
                                setData({ ...data, registrationForm: { ...(data?.registrationForm || {}), attendanceSessions: newSessions } })
                            }}>
                                + 出席環節
                            </div>
                        </div>
                    </div>


                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>微信支付訂金</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isWechatDeposit ? '是' : '否'}
                            select={(item, index) => {
                                setData({ ...data, isWechatDeposit: item === '是' })
                            }}
                        />
                    </div>
                    {data?.isWechatDeposit && <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>訂金金額 (HKD)</div>
                        <input value={data?.depositFee ?? ''} type="number" onChange={(e) => {
                            let num = parseFloat(e.target.value) || 0
                            setData({ ...data, depositFee: num < 0 ? 0 : num })
                        }} placeholder='訂金金額' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>}


                </div>
                <div className='w-full flex flex-col max-w-[700px] min-w-[300px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>封面圖片</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.preview && <div className='relative w-full'>
                            {
                                data?.preview
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.preview} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, preview: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile} data={data} />
                        </div>
                    </div>
                </div>
            </div>}

            {tab === '活動報名' && <EventApprovalPage data={data} />}
            {tab === '活動簡介' && <EventIntroduction 
                data={data}
                refresh={refresh}
                onDelete={handleSectionDeleteIntroduction}
                onAddCard={handleAddIntroduction}
                onEditKey={handleSectionEditIntroduction}
                updateOrder={handleIntroductionOrder}
            />}
            {tab==='詳細資訊' && <EventDetailsEditor
                data={data}
                refresh={refresh}
                onDelete={handleSectionDeleteDetails}
                onAddCard={handleAddDetails}
                onEditKey={handleSectionEditDetails}
                updateOrder={handleDetailsOrder}
            />}
            {/* {tab === '管理評論' && <EventComments data={data} refresh={refresh} />} */}
            {tab === '登記電郵通知' && <EventEmail data={data} refresh={refresh} onEdit={(key,value)=>{setData({...data,[key]:value})}} type='register'/>}
            {tab === '批准電郵通知' && <EventEmail data={data} refresh={refresh} onEdit={(key,value)=>{setData({...data,[key]:value})}} type='approval'/>}
            {tab === '報名表' && <EventRegistrationForm data={data} refresh={refresh} onEdit={(key,value)=>{setData({...data,[key]:value})}} />}
            
            {isDeleting && <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000099] z-[100] flex items-center justify-center">
                <div className="bg-white p-[24px] rounded-[7px] flex flex-col items-center justify-center gap-[24px]">
                    <div className="text-[16px] font-bold">確定要刪除這個活動嗎？</div>
                    <div className="text-[14px]">刪除後將無法恢復，請謹慎操作。</div>
                    <div className="flex flex-row items-center justify-center gap-[8px]">
                        <div onClick={() => { setIsDeleting(false) }} className="cursor-pointer text-[#938474] bg-[#eee] px-[16px] rounded-[8px] hover:opacity-[.5]">取消</div>
                        <div onClick={handleDelete} className="cursor-pointer text-red-500 hover:opacity-[.5] px-[16px]">刪除</div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


const DeleteButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={164}
      height={39}
      fill="none"
      {...props}
    >
      <rect width={164} height={39} fill="url(#adelete)" rx={7} />
      <path
        fill="#fff"
        d="M63.044 14.308H64.5v7.924h-1.456v-7.924Zm2.478-1.414h1.526v10.948c0 .439-.047.775-.14 1.008a1.11 1.11 0 0 1-.518.56c-.243.13-.565.215-.966.252-.392.047-.854.07-1.386.07a3.725 3.725 0 0 0-.182-.812 4.957 4.957 0 0 0-.308-.812l1.022.028h.658a.422.422 0 0 0 .224-.07c.047-.037.07-.112.07-.224V12.894Zm-4.872.28h1.442v10.99c0 .28-.033.527-.098.742a.94.94 0 0 1-.336.532 1.36 1.36 0 0 1-.56.238 2.883 2.883 0 0 1-.728.056 2.964 2.964 0 0 0-.112-.462 5.852 5.852 0 0 0-.168-.532 2.012 2.012 0 0 0-.196-.448c.13.01.252.014.364.014.112 0 .191-.005.238-.014.103 0 .154-.056.154-.168V13.174Zm-5.446 0h6.216v1.456h-4.844v11.13h-1.372V13.174Zm-.798 5.012h8.4v1.526h-8.4v-1.526Zm2.786-4.424h1.078v11.704h-1.078V13.762Zm1.722 0h1.064v11.676h-1.064V13.762Zm15.554 2.884h5.46v1.386h-5.46v-1.386Zm-.84 2.66h7.322v1.414h-7.322v-1.414Zm3.514-5.194c-.252.41-.574.835-.966 1.274-.383.439-.807.859-1.274 1.26a9.624 9.624 0 0 1-1.442 1.05 4.437 4.437 0 0 0-.378-.7 5.378 5.378 0 0 0-.448-.644 7.738 7.738 0 0 0 1.47-1.05c.476-.42.91-.863 1.302-1.33.392-.467.71-.915.952-1.344h1.47c.336.485.719.957 1.148 1.414.43.457.882.877 1.358 1.26.485.383.966.69 1.442.924-.15.187-.308.415-.476.686a6.927 6.927 0 0 0-.42.742c-.457-.27-.924-.602-1.4-.994-.467-.401-.9-.821-1.302-1.26a14.237 14.237 0 0 1-1.036-1.288Zm-.756 3.262h1.582v6.65c0 .373-.037.672-.112.896a.937.937 0 0 1-.476.546c-.224.121-.495.2-.812.238a9.594 9.594 0 0 1-1.106.056 5.578 5.578 0 0 0-.21-.784 5.648 5.648 0 0 0-.322-.77c.27.01.523.014.756.014h.476c.084-.01.14-.028.168-.056.037-.028.056-.08.056-.154v-6.636Zm-2.226 3.878 1.47.35a9.92 9.92 0 0 1-.882 1.89 7.81 7.81 0 0 1-1.148 1.512 4.722 4.722 0 0 0-.35-.308c-.14-.121-.285-.243-.434-.364a2.671 2.671 0 0 0-.406-.28 5.531 5.531 0 0 0 1.022-1.26c.308-.495.55-1.008.728-1.54Zm4.27.532 1.288-.602c.243.317.48.658.714 1.022.243.364.457.728.644 1.092.196.355.34.677.434.966l-1.386.686a4.994 4.994 0 0 0-.392-.966 23.003 23.003 0 0 0-.616-1.12 12.682 12.682 0 0 0-.686-1.078Zm-9.436-8.582h3.304v1.512h-1.834V25.76h-1.47V13.202Zm2.8 0h.266l.238-.056 1.092.63c-.112.392-.238.817-.378 1.274-.14.457-.285.905-.434 1.344-.14.439-.275.84-.406 1.204.43.532.71 1.036.84 1.512s.196.92.196 1.33c0 .448-.051.821-.154 1.12a1.275 1.275 0 0 1-.476.686 1.576 1.576 0 0 1-.378.182c-.13.047-.27.084-.42.112-.261.028-.57.037-.924.028a4.086 4.086 0 0 0-.112-.714 2.373 2.373 0 0 0-.252-.714c.13.01.243.014.336.014h.28a.674.674 0 0 0 .392-.126.485.485 0 0 0 .168-.294c.037-.14.056-.308.056-.504 0-.327-.065-.7-.196-1.12-.121-.42-.378-.863-.77-1.33.093-.317.187-.663.28-1.036.103-.383.2-.765.294-1.148.103-.383.191-.737.266-1.064.084-.336.15-.616.196-.84v-.49Zm15.694 6.874h7.35v5.6h-1.61v-4.074h-4.2v4.144h-1.54v-5.67Zm6.23-7.476 1.288 1.316c-.681.261-1.437.49-2.268.686-.83.187-1.685.34-2.562.462a52.19 52.19 0 0 1-2.548.294 3.64 3.64 0 0 0-.196-.714 5.196 5.196 0 0 0-.28-.714c.597-.065 1.2-.14 1.806-.224a32.648 32.648 0 0 0 1.792-.294c.579-.112 1.12-.233 1.624-.364.504-.14.952-.29 1.344-.448Zm-3.36 1.582h1.596v6.776h-1.596v-6.776Zm-3.738 2.506h8.918v1.596H86.62v-1.596Zm1.974 6.958H93.9v1.526h-5.306v-1.526ZM83.162 14l.952-1.218c.261.13.555.28.882.448.327.168.644.336.952.504.317.168.574.317.77.448l-.994 1.358a8.31 8.31 0 0 0-.728-.476c-.299-.177-.611-.36-.938-.546a28.715 28.715 0 0 0-.896-.518Zm-.672 3.878.91-1.246c.261.112.56.252.896.42.336.168.663.336.98.504.317.159.574.303.77.434l-.938 1.4a7.52 7.52 0 0 0-.742-.476c-.299-.177-.616-.36-.952-.546-.336-.187-.644-.35-.924-.49Zm.21 6.58c.252-.355.527-.77.826-1.246.308-.485.62-.999.938-1.54.317-.55.616-1.097.896-1.638l1.232 1.12a47.48 47.48 0 0 1-.784 1.498c-.27.513-.55 1.017-.84 1.512-.28.495-.565.97-.854 1.428L82.7 24.458Zm14.112-2.8h6.538v1.19h-6.538v-1.19Zm-.308-6.664h7v1.218h-7v-1.218Zm2.772-.98h1.526v10.038h-1.526V14.014Zm-2.856 9.87c.588-.037 1.26-.084 2.016-.14.756-.056 1.554-.117 2.394-.182l2.534-.224.014 1.274c-.793.084-1.596.168-2.408.252-.803.084-1.577.159-2.324.224-.737.075-1.414.145-2.03.21l-.196-1.414Zm1.778-4.452v.63h3.696v-.63h-3.696Zm0-1.624v.63h3.696v-.63h-3.696Zm-1.33-1.05h6.412v4.354h-6.412v-4.354Zm5.74-4.074.728 1.246c-.588.121-1.251.229-1.988.322-.728.084-1.475.154-2.24.21-.765.047-1.498.08-2.198.098a3.811 3.811 0 0 0-.154-.602 3.406 3.406 0 0 0-.224-.602c.523-.028 1.06-.06 1.61-.098.55-.047 1.092-.098 1.624-.154.541-.056 1.05-.117 1.526-.182.485-.075.924-.154 1.316-.238Zm.882 3.094h4.858v1.54h-4.858v-1.54Zm4.172 0h1.61v.742c-.037 1.437-.075 2.66-.112 3.668a73.746 73.746 0 0 1-.126 2.478c-.037.644-.098 1.148-.182 1.512-.075.364-.168.625-.28.784-.159.233-.327.397-.504.49a1.84 1.84 0 0 1-.602.224 4.672 4.672 0 0 1-.784.056c-.308.01-.63.01-.966 0a3.31 3.31 0 0 0-.154-.812 3.295 3.295 0 0 0-.322-.798 14.736 14.736 0 0 0 1.4.07.625.625 0 0 0 .28-.056.62.62 0 0 0 .21-.182c.075-.112.14-.327.196-.644.056-.327.103-.789.14-1.386.047-.607.084-1.386.112-2.338.037-.952.065-2.105.084-3.458v-.35Zm-2.828-2.94h1.61c0 1.195-.014 2.329-.042 3.402a33.88 33.88 0 0 1-.182 3.038c-.093.943-.257 1.82-.49 2.632a8.457 8.457 0 0 1-.952 2.198 6.694 6.694 0 0 1-1.582 1.75 3.106 3.106 0 0 0-.336-.448 6.62 6.62 0 0 0-.42-.462 2.78 2.78 0 0 0-.42-.35 5.854 5.854 0 0 0 1.428-1.54 7.438 7.438 0 0 0 .84-1.946c.196-.719.331-1.503.406-2.352.075-.859.117-1.778.126-2.758.009-.99.014-2.044.014-3.164Z"
      />
      <defs>
        <linearGradient
          id="adelete"
          x1={82}
          x2={82}
          y1={0}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C706B" />
          <stop offset={1} stopColor="#8C706B" stopOpacity={0.2} />
        </linearGradient>
      </defs>
    </svg>
  )

  const BackButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={129}
      height={40}
      fill="none"
      {...props}
    >
      <rect width={129} height={40} fill="url(#aback)" rx={7} />
      <path
        fill="#fff"
        d="M46.648 14.578h3.555c1.521 0 2.672.214 3.453.64.782.428 1.172 1.178 1.172 2.25 0 .433-.07.824-.21 1.173a2.122 2.122 0 0 1-.595.859c-.26.224-.578.37-.953.438v.078c.38.078.724.213 1.032.406.307.187.552.463.734.828.187.36.281.838.281 1.438 0 .692-.17 1.286-.508 1.78-.338.495-.823.876-1.453 1.141-.625.26-1.37.391-2.234.391h-4.274V14.578Zm2.422 4.524h1.407c.703 0 1.19-.11 1.46-.329.271-.224.407-.552.407-.984 0-.437-.162-.75-.485-.937-.317-.193-.823-.29-1.515-.29H49.07v2.54Zm0 1.921V24h1.578c.73 0 1.237-.14 1.524-.422.286-.281.43-.659.43-1.133 0-.28-.063-.528-.188-.742-.125-.213-.336-.38-.633-.5-.291-.12-.695-.18-1.21-.18h-1.5Zm11.72-3.937c1.17 0 2.07.255 2.694.766.625.51.938 1.286.938 2.328V26h-1.664l-.461-1.188h-.063c-.25.313-.505.568-.765.766-.26.198-.56.344-.899.438-.338.093-.75.14-1.234.14-.516 0-.98-.099-1.39-.297a2.208 2.208 0 0 1-.962-.906c-.234-.411-.351-.932-.351-1.562 0-.927.325-1.61.976-2.047.651-.443 1.628-.688 2.93-.735l1.516-.047v-.382c0-.459-.12-.795-.36-1.008-.24-.214-.573-.32-1-.32-.422 0-.836.06-1.242.18a9.63 9.63 0 0 0-1.219.452l-.789-1.609A6.775 6.775 0 0 1 59 17.297a7.539 7.539 0 0 1 1.79-.211Zm1.265 4.867-.922.031c-.771.021-1.308.16-1.61.414-.296.256-.445.592-.445 1.008 0 .365.107.625.32.782.214.15.493.226.836.226.51 0 .94-.151 1.29-.453.354-.302.53-.732.53-1.29v-.718Zm8.375 4.203c-.865 0-1.602-.156-2.211-.468-.61-.318-1.073-.808-1.39-1.47-.319-.66-.477-1.507-.477-2.538 0-1.068.18-1.938.539-2.61.364-.677.867-1.174 1.507-1.492.646-.318 1.394-.476 2.243-.476.604 0 1.125.06 1.562.18a6.08 6.08 0 0 1 1.156.413l-.703 1.844a11.095 11.095 0 0 0-1.047-.367 3.29 3.29 0 0 0-.968-.149c-.417 0-.763.1-1.04.297-.275.193-.481.485-.617.875-.135.39-.203.88-.203 1.47 0 .577.073 1.056.219 1.437.146.38.357.664.633.851.276.182.612.274 1.008.274.494 0 .934-.066 1.32-.196.385-.135.76-.323 1.125-.562v2.039c-.365.229-.748.393-1.148.492-.396.104-.899.156-1.508.156Zm7.07-12.312v5.437c0 .328-.013.657-.04.985-.025.328-.054.656-.085.984h.031c.162-.23.326-.456.492-.68.172-.224.355-.44.547-.648l2.446-2.656h2.687l-3.469 3.789L83.79 26h-2.75l-2.516-3.54-1.023.821V26h-2.383V13.844H77.5Z"
      />
      <defs>
        <linearGradient
          id="aback"
          x1={64.5}
          x2={64.5}
          y1={0}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C866B" />
          <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
        </linearGradient>
      </defs>
    </svg>
  )